(function() {
  const originalFetch = window.fetch;
  window.fetch = async function() {
    const response = await originalFetch.apply(this, arguments);

    // Check if the request URL matches the "cart/add.js" endpoint
    if (arguments[0].includes("cart/add.js")) {
      if (response.ok) {

        // Get cart count
        const res = await fetch("/cart.js");
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        
        // Call the updateCartDrawer function when the request is detected and successful
        updateCartDrawer();
      }
    }
    return response;
  };
})();

async function openCartDrawer() {
  await updateCartDrawer(); // Update the cart drawer before opening it
  const cartDrawer = document.querySelector(".cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.add("cart-drawer--active");
  }
  document.body.style.overflow = "hidden";
}

function closeCartDrawer() {
  const cartDrawer = document.querySelector(".cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.remove("cart-drawer--active");
  }
  document.body.style.overflow = "auto";
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".site-header-cart--count").forEach((el) => {
    el.setAttribute("data-header-cart-count", count);
  });
}

async function updateCartDrawer() {
  // Initial fetch
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();

  // Fetch again after 2.5 seconds
  setTimeout(async () => {
    const followUpRes = await fetch("/?section_id=cart-drawer");
    const followUpText = await followUpRes.text();
    const followUpHtml = document.createElement("div");
    followUpHtml.innerHTML = followUpText;

    const updatedBox = followUpHtml.querySelector(".cart-drawer").innerHTML;
    document.querySelector(".cart-drawer").innerHTML = updatedBox;

    addCartDrawerListeners();
  }, 2500);
}


async function handleCartUpdate(key, quantity) {
  const cartDrawerBox = document.querySelector('.cart-drawer-box');
  cartDrawerBox.classList.add('cart-drawer-box--loading');

  try {
    const res = await fetch("/cart/change.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: key, quantity: quantity }), // 'id' refers to the line item key
    });

    if (!res.ok) throw new Error("Failed to update cart");

    const cart = await res.json();
    updateCartItemCounts(cart.item_count);
    await updateCartDrawer();
    

  } catch (error) {
    console.error("Error updating cart:", error);
    // Optionally, display an error message to the user
  } finally {
    cartDrawerBox.classList.remove('cart-drawer-box--loading'); // Remove loading state
  }
}

function addCartDrawerListeners() {
  // Update quantities from buttons and input fields
  document.querySelectorAll(".cart-drawer-quantity-selector").forEach((selector) => {
    const buttonMin = selector.querySelector(".cart-drawer-quantity-selector-minus");
    const buttonPlus = selector.querySelector(".cart-drawer-quantity-selector-plus");
    const input = selector.querySelector("input");

   // Button click listener for the minus button
    if (buttonMin) {
        buttonMin.addEventListener("click", async () => {
            const rootItem = buttonMin.parentElement.parentElement.parentElement.parentElement.parentElement;
            const key = rootItem.getAttribute("data-line-item-key");
            const currentQuantity = Number(input.value);
            const newQuantity = Math.max(0, currentQuantity - 1); // Prevent negative quantities
            input.value = newQuantity; // Update the input for immediate feedback
            await handleCartUpdate(key, newQuantity);
        });
    }

    // Button click listener for the plus button
    if (buttonPlus) {
        buttonPlus.addEventListener("click", async () => {
            const rootItem = buttonPlus.parentElement.parentElement.parentElement.parentElement.parentElement;
            const key = rootItem.getAttribute("data-line-item-key");
            const currentQuantity = Number(input.value);
            const newQuantity = currentQuantity + 1; // Increase the quantity
            input.value = newQuantity; // Update the input for immediate feedback
            await handleCartUpdate(key, newQuantity);
        });
    }

    // Input change listener
    if (input) {
      input.addEventListener("change", async () => {
        const rootItem = input.parentElement.parentElement.parentElement.parentElement.parentElement;
        const key = rootItem.getAttribute("data-line-item-key");
        const inputQty = Math.max(0, Number(input.value)); // Prevent negative quantities
        await handleCartUpdate(key, inputQty);
      });
    }
  });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document.querySelectorAll(".cart-drawer-header-right-close, .cart-drawer").forEach((el) => {
    el.addEventListener("click", closeCartDrawer);
  });
}

// Use event delegation for dynamically added forms
document.addEventListener("submit", async function(e) {
  const form = e.target;

  // Check if the form is a cart add form
  if (form.matches('form[action="/cart/add"]')) {
    e.preventDefault();

    // Submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Open cart drawer
    openCartDrawer();
  }
});

// Use event delegation for dynamically added add-to-cart buttons
document.addEventListener("click", async function(e) {
  const button = e.target.closest(".productitem--action-atc");

  // Check if the clicked element is the add-to-cart button
  if (button) {
    e.preventDefault();

    const buttonText = button.querySelector(".atc-button--text")?.textContent.trim();
    if (buttonText === "Opties kiezen") {
      return;
    }

    const variantId = button.getAttribute("data-variant-id");

    try {
      // Add the item to the cart via ajax
      await fetch("/cart/add", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);

      // Open cart drawer
      openCartDrawer();
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  }
});

// Add listener for opening the cart drawer from cart link
document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", async (e) => {
    e.preventDefault();      
    openCartDrawer();
  });
});

// Initial call to add listeners
addCartDrawerListeners();
